// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Bhes6","input":"styles_input__bSFpH","errorMsg":"styles_errorMsg__YQeC8","error":"styles_error__LxzNC"};